import { render, staticRenderFns } from "./ElementSetting.vue?vue&type=template&id=f898a004&scoped=true"
import script from "./ElementSetting.vue?vue&type=script&lang=js"
export * from "./ElementSetting.vue?vue&type=script&lang=js"
import style0 from "./ElementSetting.vue?vue&type=style&index=0&id=f898a004&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f898a004",
  null
  
)

export default component.exports